import { Button, Divider, Grid, MenuItem, Modal, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { LOGIN } from "../../global/urlMapping";
import { Redirect } from "../tools/Redirect";
import { AuthComp } from "../../auth/AuthComp";
import { useEffect, useMemo } from "react";
import { isNotNullUndefined, validateAddress, validateMail, validateMunicipalityCode, validateTelefono, validateZipCode } from "../../functions/inputValidation";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { profiloAriannaSelector } from "../../modules/screening/selectors";
import { ricercaComuniSelector, ricercaIscrizioneSelector } from "../../modules/anagrafe/selectors";
import { ReactComponent as Warning } from "../../resources/icone/warning.svg"
import { patchProfiloAriannaAction } from "../../modules/screening/actions";
import { isDomicilioAttivo } from "../../global/multiAsl";

export const Profilo = () => {
    const dispatch = useDispatch();

    const profiloArianna = useSelector(profiloAriannaSelector)
    const ricercaComuni = useSelector(ricercaComuniSelector)
    const datiIscrizioneAsr = useSelector(ricercaIscrizioneSelector)?.value?.DatiMinimiIscrizione
    const aslAssistito = datiIscrizioneAsr?.CodiceAreaAssistenza ?? datiIscrizioneAsr?.CodiceAslAssistenza

    const [screeningAddress, setScreeningAddress] = useState(validateAddress(profiloArianna?.value?.patient?.screeningAddress));
    const [screeningZipCode, setScreeningZipCode] = useState(validateZipCode(profiloArianna?.value?.patient?.screeningZipCode));
    const [screeningMunicipalityCode, setScreeningMunicipalityCode] = useState(validateMunicipalityCode(profiloArianna?.value?.patient?.screeningMunicipalityCode));
    const [telefono, setTelefono] = useState(validateTelefono(profiloArianna?.value?.patient?.personalMobile));
    const [mail, setMail] = useState(validateMail(profiloArianna?.value?.patient?.personalEmail));

    const [modaleWarning, setModaleWarning] = useState(false)

    const buttonSalvaIsDisabled = () => {
        return (screeningAddress.error || screeningMunicipalityCode.error || screeningZipCode.error || telefono.error || mail.error)
    }

    const salvaIndirizzo = () => {
        if (!isNotNullUndefined(screeningAddress.value).error &&
            !isNotNullUndefined(screeningMunicipalityCode.value).error &&
            !isNotNullUndefined(screeningZipCode.value).error &&
            !isNotNullUndefined(telefono.value).error) {

            setModaleWarning(true)
        }
    }
    const aggiornaIndirizzo = () => {
        const patientInfoBody = {
            "screeningTypeCode": "CL",
            "address": screeningAddress.value,
            "municipalityCode": screeningMunicipalityCode.value,
            "zipCode": screeningZipCode.value,
            "mobile": telefono.value,
            "email": mail.value
        }
        dispatch(patchProfiloAriannaAction(patientInfoBody));
        //navigate(-1);
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case "telefono":
                setTelefono(validateTelefono(value))
                break;
            case "mail":
                setMail(validateMail(value))
                break;
            case "screeningAddress":
                setScreeningAddress(validateAddress(value));
                break;
            case "screeningMunicipalityCode":
                setScreeningMunicipalityCode(validateMunicipalityCode(value))
                break;
            case "screeningZipCode":
                setScreeningZipCode(validateZipCode(value))
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [dispatch])

    const comuni = useMemo(() => {
        return ricercaComuni?.value?.Comuni?.map((comune) => ({
            CodIstat: aslAssistito === '070103' ? comune.CodIstat.substring(1) : comune.CodIstat,
            NomeComune: comune?.NomeComune
        }))
    }, [ricercaComuni, aslAssistito]);

    return (
        <AuthComp fallback={< Redirect link={LOGIN} />} >
            <>
                <Box sx={{
                    flexGrow: 1,
                    overflow: 'hidden',
                    width: "100%"
                }}>

                    <Box sx={{ x: 'auto' }}>
                        <Grid container wrap="nowrap" spacing={2}>
                            <Grid item xs zeroMinWidth>

                                <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                    <Typography
                                        component='h1'
                                        sx={{
                                            color: "#005397",
                                            margin: "auto",
                                            textAlign: "center",
                                            fontSize: { xs: "14px", md: "24px" },
                                            fontWeight: 700,
                                        }}
                                    >
                                        {isDomicilioAttivo(aslAssistito) ? "Modifica indirizzo" : "Profilo"}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box sx={{ my: 4, mx: 'auto' }}>
                        <Grid container wrap="nowrap" spacing={2}>
                            <Grid item> </Grid>
                            <Grid item xs zeroMinWidth>
                                <Box
                                    sx={{
                                        width: "100%",
                                        margin: "auto",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <Box
                                        sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}
                                    >

                                        <TextField
                                            disabled={!isDomicilioAttivo(aslAssistito)}
                                            error={screeningAddress.error}
                                            helperText={<Typography component={'span'} sx={{ wordWrap: 'break-word', fontWeight: 600 }}>
                                                {screeningAddress.messageError}
                                            </Typography>}
                                            onChange={handleChange}
                                            variant="standard"
                                            value={screeningAddress.value}
                                            name="screeningAddress"
                                            label="Indirizzo"
                                            autoFocus
                                            sx={{ width: { xs: "90%", md: "50%" }, mb: "20px" }}
                                            autoComplete="off"
                                        />
                                        <TextField
                                            error={screeningZipCode.error}
                                            helperText={<Typography component={'span'} sx={{ wordWrap: 'break-word', fontWeight: 600 }}>
                                                {screeningZipCode.messageError}
                                            </Typography>}
                                            onChange={handleChange}
                                            variant="standard"
                                            value={screeningZipCode.value}
                                            name="screeningZipCode"
                                            label="Codice cap"
                                            autoFocus
                                            sx={{ width: { xs: "90%", md: "50%" }, mb: "20px" }}
                                            autoComplete="off"
                                        />
                                        <TextField
                                            error={screeningMunicipalityCode.error}
                                            helperText={<Typography component={'span'} sx={{ wordWrap: 'break-word', fontWeight: 600 }}>
                                                {screeningMunicipalityCode.messageError}
                                            </Typography>}
                                            onChange={handleChange}
                                            value={screeningMunicipalityCode.value}
                                            name="screeningMunicipalityCode"
                                            select
                                            label="Comune"
                                            variant="standard"
                                            autoFocus
                                            sx={{ width: { xs: "90%", md: "50%" }, mb: "20px" }}
                                        >
                                            {comuni?.map((comune) => (
                                                <MenuItem key={comune?.CodIstat} value={comune?.CodIstat}>
                                                    {comune?.NomeComune}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        <TextField
                                            error={telefono.error}
                                            helperText={<Typography component={'span'} sx={{ wordWrap: 'break-word', fontWeight: 600 }}>
                                                {telefono.messageError}
                                            </Typography>}
                                            onChange={handleChange}
                                            variant="standard"
                                            value={telefono?.value}
                                            name="telefono"
                                            label="Telefono"
                                            autoFocus
                                            sx={{ width: { xs: "90%", md: "50%" }, mb: "20px" }}
                                            autoComplete="off"
                                        />
                                        <TextField
                                            error={mail.error}
                                            helperText={<Typography component={'span'} sx={{ wordWrap: 'break-word', fontWeight: 600 }}>
                                                {mail.messageError}
                                            </Typography>}
                                            onChange={handleChange}
                                            variant="standard"
                                            value={mail.value}
                                            name="mail"
                                            label="E-mail"
                                            autoFocus
                                            sx={{ width: { xs: "90%", md: "50%" }, mb: "20px" }}
                                            autoComplete="off"
                                        />
                                        <Box sx={{ height: "100px", width: "100%", display: "flex" }}>
                                            <Button
                                                disabled={buttonSalvaIsDisabled()}
                                                onClick={() => {
                                                    salvaIndirizzo()
                                                }}
                                                variant="contained"
                                                disableRipple
                                                disableFocusRipple
                                                disableTouchRipple
                                                sx={{
                                                    backgroundColor: "#005397",
                                                    margin: "auto",
                                                    height: "50px",
                                                    width: { xs: '60%', md: '450px' },
                                                    borderRadius: "20px !important",
                                                }}
                                            >
                                                <Typography sx={{ color: "white", fontSize: '16px', fontWeight: 500 }}> Aggiorna informazioni </Typography>
                                            </Button>
                                        </Box>

                                    </Box>
                                </Box>

                            </Grid>
                        </Grid>
                    </Box>

                </Box>
                {
                    modaleWarning &&
                    <Modal
                        open={modaleWarning}
                        disableAutoFocus
                        sx={{ width: "100%", display: "flex" }}
                    >
                        <Box
                            sx={{
                                width: "380px",
                                minHeight: "320px",
                                display: "flex",
                                flexDirection: "column",
                                margin: "auto",
                                backgroundColor: "white",
                                borderRadius: "20px",
                            }}
                        >
                            <Box
                                sx={{
                                    minHeight: "120px",
                                    display: "flex",
                                    width: "100%",
                                    margin: "auto",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Warning
                                    sx={{
                                        display: "flex",
                                        margin: "auto",
                                    }}
                                />
                                <Typography
                                    sx={{
                                        color: "#D1AE00",
                                        wordWrap: "break-word",
                                        margin: "auto",
                                        fontSize: "20px",
                                        textAlign: "center",
                                        marginBottom: "5px"
                                    }}
                                    component="h1"
                                >
                                    Attenzione
                                </Typography>
                            </Box>
                            <Divider
                                variant="middle"
                                sx={{
                                    width: "70%",
                                    margin: "0px auto",
                                }}
                            />
                            <Typography
                                sx={{
                                    fontSize: "16px",
                                    color: "black",
                                    fontWeight: "medium",
                                    textAlign: "center",
                                    margin: "auto",
                                    mx: "10px"
                                }}
                            >
                                L'aggiornamento dell'indirizzo non avrà effetto su eventuale kit già in spedizione.
                            </Typography>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-around",
                                    mt: "20px",
                                    mb: "20px",
                                }}
                            >
                                <Button
                                    sx={{
                                        borderWidth: '2px',
                                        borderColor: '#005397',
                                        "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px', color: "white" },
                                        color: '#005397',
                                        borderRadius: '20px',
                                        fontWeight: 700,
                                        fontSize: { md: "14px", xs: "12px" }
                                    }}
                                    variant="outlined"
                                    onClick={() => { setModaleWarning(false); }}
                                >
                                    Annulla
                                </Button>
                                <Button
                                    sx={{
                                        borderWidth: '2px',
                                        borderColor: '#005397',
                                        bgcolor: "#005397",
                                        "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px' },
                                        color: 'white',
                                        borderRadius: '20px',
                                        fontWeight: 700,
                                        fontSize: { md: "14px", xs: "12px" }
                                    }}
                                    variant="outlined"
                                    onClick={() => { setModaleWarning(false); aggiornaIndirizzo(); }}
                                >
                                    Aggiorna
                                </Button>
                            </Box>
                        </Box>
                    </Modal>
                }
            </>
        </AuthComp>
    );
}